import { render } from "./CadastroGA.vue?vue&type=template&id=397b082d&scoped=true"
import script from "./CadastroGA.vue?vue&type=script&lang=js"
export * from "./CadastroGA.vue?vue&type=script&lang=js"

import "./CadastroGA.vue?vue&type=style&index=0&id=397b082d&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397b082d"]])

export default __exports__